<template>
    <div id="snackbar">
        <v-snackbar
            v-for="snackbar in snackbars"
            :key="snackbar.text"
            v-model="snackbar.show"
            :top="true"
            :color="snackbar.type"
            :timeout="snackbar.timeout"
            :right="true"
            :multi-line="true"
            :absolute="true"
        >
            <div class="pr-3" v-html="snackbar.text"></div>
            <template v-slot:action="{ attrs }">
                <v-btn class="elevation-0" :color="snackbar.type" v-bind="attrs" @click="hideSnackbar(snackbar)">
                    <v-icon x-small>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState(['snackbars']),
    },
}
</script>

<style>
#snackbar {
    position: fixed;
    top: 0;
    right: 15px;
    z-index: 9999999999;
    display: flex;
    width: 200vw;
    flex-direction: column-reverse;
    align-items: flex-end;
    justify-content: space-around;
}
#snackbar .v-snack {
    position: relative !important;
    margin-bottom: 4px;
}
</style>
